import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { KBHelpArticleResponse, HelpArticleId } from '@business/entities/helpArticle';
import { KnowledgeBaseAPI } from '@business/api/knowledgeBase';
import { handleMessage, requestMessage } from '@business/messages';

export class KnowledgeBaseBloc extends BaseBloc {
  private readonly kbRepo = new Repository<KBHelpArticleResponse>({
    getItemId: item => item.id,
  });

  readonly articles$ = this.kbRepo.items$;
  readonly selectArticle = this.kbRepo.selectItem;

  onReset() {
    this.kbRepo.reset();
  }

  fetchArticle = (id: HelpArticleId) => {
    return KnowledgeBaseAPI.fetchHelpArticle(id).pipe(
      this.kbRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_help_articles_error') }),
    );
  };

  sendFeedback = (id: HelpArticleId, email: string) => {
    return KnowledgeBaseAPI.sendArticleFeedback(id, email).pipe(
      this.kbRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('store_help_article_feedback'),
      }),
    );
  };
}
